import { NEW_BASE_URL } from "../Constant";
import { newReconDownloadExcelAPI, newReconGetServiceAPI, newReconServiceAPI } from "./APIutils";

export function fetchReportNames() {
  const url = `${NEW_BASE_URL}/v1/reconReports/report-names`;
  return newReconGetServiceAPI(url);
}

export function generateReport(
  cityIdArr,
  reportType,
  fromDate,
  toDate,
) {
  const url = `${NEW_BASE_URL}/v1/reconReports`;

  return newReconServiceAPI(url, {
    cityIdArr,
    reportType,
    fromDate,
    toDate,
  });
}

export function fetchGeneratedReportsService({ pageNo, pageSize }) {
  const url = `${NEW_BASE_URL}/v1/reconReports?pageNo=${pageNo}&pageSize=${pageSize}`;
  return newReconGetServiceAPI(url);
}

export function fetchReportDownloadableLink(reportStorageKey) {
  const url = `${NEW_BASE_URL}/v1/reconReports/presigned-link?reportName=${reportStorageKey}`;
  return newReconGetServiceAPI(url);
}

export function downloadReport(url) {
  return newReconDownloadExcelAPI(url);
}
